module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/15168879152e149b709100995242e833.png";